import React, {Component} from 'react';
import PrintPreview from '../PrintPreview'
import ReportStore from 'stores/ReportStore'
import './Print.css';

const DEFAULT_ROW = 41
class PrintReportConsumablesMaterial extends Component {

    constructor(...args) {
      super(...args)
        
      this.state = {loading:false,dataList:[],data:[],report_title:'กำลังดึงข้อมูล..'}

      var cssPagedMedia = (function() {
        var style = document.createElement('style');
        document.head.appendChild(style);
        return function (rule) {
          style.innerHTML = rule;
        };
      }());
  
      cssPagedMedia.size = function(size) {
        cssPagedMedia('@page {size: ' + size + '}');
      };
      cssPagedMedia.size('portrait');
    }

    componentDidMount() {
        this.loadData()
    }

    loadData() {
        if (this.props.isRange=='false'&&this.props.year!=undefined&&this.props.month!=undefined&&this.props.day!=undefined&&this.props.groupId!=undefined) {
            if (this.props.groupId=='all') {
                ReportStore.loadReportProductTransactionRecord(this.props.year,this.props.month,this.props.day,'officemate','export','',(result)=>{
                    this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
                })
            } else {
                ReportStore.loadReportConsumablesProductTransactionRecord(this.props.year,this.props.month,this.props.day,'officemate','export',this.props.groupId,(result)=>{
                    this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
                })
            }
        } else if (this.props.isRange=='true'&&this.props.startDate!=undefined&&this.props.endDate!=undefined&&this.props.groupId!=undefined) {
            if (this.props.groupId=='all') {
                ReportStore.loadReportProductTransactionRecordRange(this.props.startDate,this.props.endDate,'officemate','export','',(result)=>{
                    this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
                })
            } else {
                ReportStore.loadReportConsumablesProductTransactionRecordRange(this.props.startDate,this.props.endDate,'officemate','export',this.props.groupId,(result)=>{
                    this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
                })
            }
        } else {
            this.setState({data:[],dataList:this.getPagination([]),report_title:'ไม่พบข้อมูล'})
        }
    }

    getNumberFormat(value) {
        let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
        _val = parseFloat(_val)
        return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    }
    
    getSummary(field) {
        let {data} = this.state
        let total = 0
        data.forEach((item,index)=> {
            total += (item[field]===''||item[field]===null||item[field]===undefined||isNaN(item[field])?0:item[field]*1)
        }) 
        return total
    }
    
    getSummaryAmount(field) {
        let {data} = this.state
        let total = 0
        data.forEach((item,index)=> {
          let quantity = (item['quantity']===''||item['quantity']===null||item['quantity']===undefined||isNaN(item['quantity'])?0:item['quantity']*1)
          let value = (item[field]===''||item[field]===null||item[field]===undefined||isNaN(item[field])?0:item[field]*1)
          total += (quantity*value)
        }) 
        return total
    }

    getPagination(data) {
        let newData = []
        let allData = []
        let checkRow = 0
        data.forEach(function(item,index) {
            if (checkRow<DEFAULT_ROW)
              checkRow++
              newData.push(item)
    
            if (checkRow===DEFAULT_ROW-1||index===data.length-1) {
              allData.push(newData)
              checkRow = 0
              newData = []
            }
        })  
        
        return allData
    }

    renderRowData(data,indexs) {
        let {groupId} = this.props
        if (data.length==0) {
          return(<tr><td colSpan={10}>ไม่พบข้อมูล</td></tr>)
        } else {
          return data.map((item, index) => (
            <tr key={index}>
              <td className='text-center'>{(indexs*40)+index+1}</td>
              <td className='text-center'>{item.category_name}</td>
              <td className='text-left'>{item.description}</td>
              <td className='text-left'>{item.description}</td>
              <td className='text-center'>{item.quantity}</td>
              <td className='text-center'>{item.unit}</td>
              <td className='text-right'>{this.getNumberFormat(item.price_per_unit*item.quantity)}</td>
              <td className='text-right'>{this.getNumberFormat(item.price_per_unit)}</td>
              <td className='text-right'>{this.getNumberFormat(item.cost_per_unit*item.quantity)}</td>
              <td className='text-right'>{this.getNumberFormat(item.cost_per_unit)}</td>
            </tr>
          ))
        }
    }

    renderTable(item,index,length) {
        return(
            <table className='table table-print-report-material'>
                <tbody>
                    <tr>
                        <td className='text-center' style={{width:'50px'}}>ลำดับ</td>
                        <td className='text-center' style={{width:'90px'}}>ประเภทสินค้า</td>
                        <td className='text-center' style={{width:'150px'}}>ชื่อสินค้า</td>
                        <td className='text-center' style={{width:'200px'}}>รายละเอียด</td>
                        <td className='text-center' style={{width:'90px'}}>จำนวนเบิก</td>
                        <td className='text-center' style={{width:'90px'}}>หน่วย</td>
                        <td className='text-center' style={{width:'100px'}}>มูลค่าคลังทั้งหมด</td>
                        <td className='text-center' style={{width:'100px'}}>มูลค่าคลัง<br/>ต่อหน่วย</td>
                        <td className='text-center' style={{width:'100px'}}>ราคาต้นทุน<br/>ปัจจุบัน</td>
                        <td className='text-center' style={{width:'100px'}}>ราคาต้นทุน<br/>ปัจจุบันต่อหน่อย</td>
                    </tr>
                    {this.renderRowData(item,index)}
                    {length-1===index?
                    <tr>
                        <td colSpan={4} className='text-right'>ยอดรวมสทุธิ</td>
                        <td className='text-center'>{this.getNumberFormat(this.getSummary('quantity'))}</td>
                        <td className='text-right'></td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummaryAmount('price_per_unit'))}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('price_per_unit'))}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummaryAmount('cost_per_unit'))}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('cost_per_unit'))}</td>
                    </tr>
                    :''}
                </tbody>
            </table>
        )
    }

    renderComponentPage(item,index,length) {
        return(  
            <div className='font-print' key={index}>
                <header className="text-center">
                    <h2>{this.props.title}</h2>
                </header>
                <div>
                    {this.renderTable(item,index,length)}
                </div>
            </div>
        )    
    }
    
    renderNoData() {
        return(
          <div className='font-print'>
            <header className="text-center">
              <h2>{this.state.report_title}</h2>
            </header>
          </div>
        )
    }

    render() {
        let {loading,dataList} = this.state
        if (dataList.length==0) {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                >
                    {this.renderNoData()}    
                </PrintPreview>
            )
        } else {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                >
                    {
                        dataList.map((item,index)=>{
                            return(
                                this.renderComponentPage(item,index,dataList.length)
                            )
                        })   
                    }
                </PrintPreview>
            )
        }      
    }
}

PrintReportConsumablesMaterial.defaultProps = {
    title: 'ตารางรายงานการเบิกใช้วัสดุสิ้นเปลือง',  
    mode : '',
    workNo : ''
  }
  export default PrintReportConsumablesMaterial;


// WEBPACK FOOTER //
// ./src/view/print/material/PrintReportConsumablesMaterial.js